// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c30fd00c","513":"65ddc235"}[chunkId] + ".chunk.js";
};